// Required for Google+ sharing
(function() {
  var po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;
  po.src = 'https://apis.google.com/js/plusone.js';
  var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);
})();


/* 
Change the featured image by fading out the current image,
loading the new one, resizing the container to the new
dimensions and then fading in the new image.
*/

function setFeaturedImage(newImg) {
	var current_height = 0;
	
	$('.product #product-thumbs a').removeClass('active');
	newImg.addClass('active');
	
	current_height = $('.product #featured-image img').outerHeight();
	$(".product #featured-image").css('height', current_height);
	
	$(".product #featured-image .icon-zoom").hide();

	$(".product #featured-image img").animate({
	    opacity: 0
	  }, 300, function() {
			
			var img = $(this);
			
			img.parent('a').attr('href', newImg.attr('href'));
			img.parent('a').attr('data-image-index', newImg.attr('data-image-index'));
			img.attr('src', newImg.attr('data-grande-image'));
	    img.one('load', function() {
				
				var new_height = $('.product #featured-image img').outerHeight();
				
				$(".product #featured-image").animate({
				    height: new_height
				  }, 800, 'easeInOutQuint', function() {
						$(".product #featured-image img").animate({
						    opacity: 1
						  }, 300, function() {
							
							$(".product #featured-image .icon-zoom").css('display', 'block').css('opacity', 0).animate({
							    opacity: 1
							  }, 300, function() {
								$(this).click(function(){
									$(".product #featured-image a").trigger('click');
								})
							});
							
						});
				  });
			}).each(function() {
				if(this.complete) $(this).load();
			});
			
	  });

}

/* 
Fade each collection list item image in as it's loaded.
*/

function loadProductImage(product){
	var current_height = 0;
	var img = $(product).find('.image img');
	
	img.hide();
	img.one('load', function() {
		$(product).find('.image').animate({
		    height: img.outerHeight()
		  }, 500, 'easeOutQuint', function() {
				img.fadeIn(300);
		  });
	}).each(function() {
		if(this.complete) $(this).load();
	});
}


// Display the login form on the customer account login page
function showLoginForm() {
	$('#customer-reset-password').hide();
	$('#customer-login').show();
}

// Display the recover password form on the customer account login page
function showRecoverPasswordForm() {
	$('#customer-login').hide();
	$('#customer-reset-password').show();
}


jQuery(document).ready(function($) {
	
	
	// Global
	// -------------------
	
	
	/*  Open external links in new window  */
	$('[data-target=_blank]').attr('target', '_blank')
	$('[rel=tooltip]').tooltip()
	
	
	/*  Fancybox  */
	
	$("a.fancybox").fancybox({
		padding:0,
		'titleShow': false,
		overlayColor: '#ffffff',
		overlayOpacity: 0.2
	});

	
	
	// Slideshows
	// -------------------
	
	if( jQuery().slides) {
		    var slider = jQuery('#index-slider');
				
				jQuery('#index-slider').fadeIn();
				
			  slider.slides({
					preload: true,
					preloadImage: slider.attr('data-loader'),
					autoHeight: false,
					bigTarget: false,
					generateNextPrev: true,
					generatePagination: true,
					paginationClass: 'slides_pagination',
					next: 'slides_next',
					prev: 'slides_prev',
					crossfade: true,
					effect: slider.attr('data-transition'),
					slideSpeed: parseInt(slider.attr('data-transition-duration')),
					fadeSpeed: parseInt(slider.attr('data-transition-duration')),
					slideEasing: 'easeInOutQuint',
					fadeEasing: 'easeInOutQuad',
					play: slider.attr('data-duration')
		    });
		}
		
	// Collections
	// -------------------

	$('.collection .product').each(function(){ 
		loadProductImage(this);
	});
	
	$('.list-collections .collection-item').hover(
	  function () {
	    $(this).addClass('hover');
	  }, 
	  function () {
	    $(this).removeClass('hover');
	  }
	);	
	
	$('.collection .product').hover(
	  function () {
	    $(this).addClass('hover');
	  }, 
	  function () {
	    $(this).removeClass('hover');
	  }
	);
	
		
	// Product
	// -------------------
	
	// If on the product detail page hide and then fade in the featured image
	if( $(".product #featured-image").length ){
		$(".product #featured-image img").css('opacity', 0);
		setFeaturedImage($(".product #featured-image a").first());
	}

	// Launch the fancybox when the featured image is clicked
	$(".product #featured-image a").click(function(e){
		$('a.fancybox').eq($(this).attr('data-image-index')-1).trigger('click');
		e.preventDefault();
	});
	
	// Add 'active' class to the first thumbnail to prevent reloading the
	// existing featured image
	$('.product #product-thumbs a').first().addClass('active');
	
	// Toggle 'hover' class on thumbnails to determine if clicked on by a user
	// or through jQuery (to launch the fancybox)
	$('.product #product-thumbs a').hover(
	  function () {
	    $(this).addClass('hover');
	  },
	  function () {
	    $(this).removeClass('hover');
	  }
	).click(function(e){
		if( !$(this).hasClass('active') && $(this).hasClass('hover') ){
			setFeaturedImage($(this));
		}
		e.preventDefault();
	});
	
	
	// Blog
	// -------------------
	
	/* Set comment form to horizontal */
	$("#comment-form form").addClass('form-horizontal');
	
	
	// Contact page
	// -------------------
	
	/* Set comment form to horizontal */
	$("#contact-form form").addClass('form-horizontal');
	
	
	// Widgets
	// -------------------
	
	// Twitter feed
	
	$("#twitter-feed").tweet({
		avatar_size: 30,
		count: $("#twitter-feed").attr("data-limit"),
		username: $("#twitter-feed").attr("data-source"),
		favorites: false,
		template: "{text} <small>{time}</small>",
		loading_text: "loading tweets..."
	});
	
	$("#twitter-feed ul li").live("mouseover", function(){
		$(this).addClass('hover');
	});
	
	$("#twitter-feed ul li").live("mouseout", function(){
		$(this).removeClass('hover');
	});
	
	$("#twitter-feed ul li").live("click", function(){
		// window.open($(this).find(".tweet_time a").first().attr("href"));
	});
	
	$("#twitter-feed ul li .tweet_time a").live("click", function(){
		e.preventDefault();
	});	
	
	// Social links
	$('.widget-social-links .social-network a').tooltip()
	
	
	// Cart
	// -------------------
	
	$('.cart a#toggle-order-note').toggle(
	  function(){
			$('.cart #order-note').slideDown('fast');
			return false;
	  },
	  function(){
	  	$('.cart #order-note').slideUp('fast');
			return false;
	  });
	
	
	// Customer accounts
	// -------------------
	
	if (window.location.hash == '#recover') { showRecoverPasswordForm() }

	$('#customer-account a#reset-password').click(function(e){
		showRecoverPasswordForm()
	});
	
	$('#customer-account a#reset-password-cancel').click(function(e){
		showLoginForm()
	});
	
	$('#customer-account .customer_address form').addClass('form-horizontal');
	
	
	// Footer
	// -------------------
	
	$('footer #payment-methods a').tooltip()
	
});